export function initTimeline() {
  const timelineSection = document.querySelector('#how-it-works');
  const timelineFill    = document.querySelector('.timeline-fill');
  const timelineLine    = document.querySelector('[data-timeline-line]');

  if (!timelineSection || !timelineFill || !timelineLine) return;

  function updateTimelineFill() {
    const lineRect   = timelineLine.getBoundingClientRect();
    const lineHeight = lineRect.height - 64; // top/bottom 32px offsets
    const sectionRect = timelineSection.getBoundingClientRect();
    const viewH      = window.innerHeight;
    const scrolled   = viewH - sectionRect.top;
    const total      = sectionRect.height + viewH;
    const progress   = Math.max(0, Math.min(1, scrolled / total));
    timelineFill.style.height = Math.round(progress * lineHeight) + 'px';
  }

  window.addEventListener('scroll', updateTimelineFill, { passive: true });
  updateTimelineFill();
}
